import React, { useEffect, useState } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import queryString from 'query-string';

import Header from '../../components/Header';

import './index.css';

interface SecureAccountResponse {
    message: string;
    error: boolean;
}

const headerTitle = 'Report Unauthorized Login';
const headerDescription = 'We are taking the following steps to secure your account:';

const AccountLock: React.FC = () => {
    const location = useLocation();
    const { token } = queryString.parse(location.search);

    const [secureAccountResponse, setSecureAccountResponse] = useState<SecureAccountResponse | null>(null);

    const renderSuccessBody = () => (
        <>
            <Header title={headerTitle} description={headerDescription} />
            <ul className="secure-items-list">
                <li>Locking your account to prevent any further unauthorized access.</li>
                <li>Logging your account out of all devices</li>
                <li>Sending you a password reset email</li>
            </ul>

            <hr className="security-divider" />

            <h2 className="header-title">Next Steps</h2>
            <div className="next-steps-paragraph">
                <p>You'll soon receive an email to reset your password.</p>
                <p>
                    Your account will remain locked until you change your password. We strongly encourage you to do this
                    ASAP.
                </p>
            </div>
        </>
    );

    const renderErrorBody = () => (
        <>
            <Header title={headerTitle} description={''} />
            <div className="error-paragraph">Looks like this link has expired!</div>
            <div className="error-paragraph">Contact support to report the unauthorized login immediately.</div>
            <button className="support-button-cta">
                <a
                    className="support-href-cta"
                    href="mailto:mailto:support@slicelife.com?subject=Unauthorized Login - Expired Link&body=RE: New Login on Slice - Expired Login%0D%0A%0D%0AMy unauthorized account link has expired."
                >
                    Contact Support
                </a>
            </button>
        </>
    );

    const submitToken = async (token: string) => {
        try {
            const response = await fetch('/api/users/secure', {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ token }),
            });

            if (!response.ok) {
                const json = await response.json();
                throw new Error(json.error);
            } else {
                setSecureAccountResponse({
                    message: 'Successful',
                    error: false,
                });
            }
        } catch (error) {
            setSecureAccountResponse({
                message: error.message,
                error: true,
            });
        }
    };

    useEffect(() => {
        if (token && typeof token === 'string') {
            submitToken(token);
        }
    }, [token]);

    if (!token) {
        return <Redirect to="/not-found" />;
    }

    if (secureAccountResponse === null) {
        return null;
    }

    return (
        <div className="index-container">
            <div className="index-form-wrapper">
                {secureAccountResponse !== null && secureAccountResponse.error === true
                    ? renderErrorBody()
                    : renderSuccessBody()}
            </div>
        </div>
    );
};

export default AccountLock;
